/**
 * SHIM for @emotion/use-insertion-effect-with-fallbacks
 * Fixes circular initialization with React by using lazy evaluation
 */

// Import React once at module level
import React from 'react';

// Lazy getter - only evaluate when called
const getInsertionEffect = () => {
  return (React as any).useInsertionEffect;
};

export const useInsertionEffectAlwaysWithSyncFallback = (create: () => void | (() => void)) => {
  const useInsertionEffect = getInsertionEffect();
  if (useInsertionEffect) {
    return useInsertionEffect(create);
  }
  // Sync fallback
  return create();
};

export const useInsertionEffectWithLayoutFallback = (
  create: () => void | (() => void),
  deps?: React.DependencyList
) => {
  const useInsertionEffect = getInsertionEffect();
  if (useInsertionEffect) {
    return useInsertionEffect(create, deps);
  }
  return React.useLayoutEffect(create, deps);
};

export const useInsertionEffectWithFallbacks = (
  create: () => void | (() => void),
  deps?: React.DependencyList
) => {
  const useInsertionEffect = getInsertionEffect();
  if (useInsertionEffect) {
    return useInsertionEffect(create, deps);
  }
  return React.useEffect(create, deps);
};

export default useInsertionEffectWithFallbacks;
